import { Outlet, NavLink } from "react-router-dom";
import { SIGNUP_FORM_URL } from "./external-links";

export function WebsiteShell() {
  return (
    <div className="site">
      {/* Organic gradient background with water ripples */}
      <div className="site-bg" aria-hidden="true">
        <div className="ripple ripple-1" />
        <div className="ripple ripple-2" />
        <div className="ripple ripple-3" />
        <div className="ripple ripple-4" />
        <div className="ripple ripple-5" />
      </div>

      <header className="site-header">
        <NavLink to="/" className="site-logo">
          Kin
        </NavLink>

        <nav className="site-nav">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `site-nav-link${isActive ? " active" : ""}`
            }
          >
            Vault
          </NavLink>
          <NavLink
            to="/marketplace"
            className={({ isActive }) =>
              `site-nav-link${isActive ? " active" : ""}`
            }
          >
            Marketplace
          </NavLink>
          <NavLink
            to="/company"
            className={({ isActive }) =>
              `site-nav-link${isActive ? " active" : ""}`
            }
          >
            Company
          </NavLink>
        </nav>

        <div className="site-header-actions">
          <a href="#" className="site-cta-secondary">
            Sign In
          </a>
          <a href={SIGNUP_FORM_URL} target="_blank" rel="noopener noreferrer" className="site-cta-primary">
            Create an Account
          </a>
        </div>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="footer-inner">
          <a href="/company" className="footer-link">Company</a>
          <a href="/marketplace" className="footer-link">Marketplace</a>
          <a href="#" className="footer-link">For Creators</a>
          <a href="#" className="footer-link">Privacy Policy</a>
          <a href="#" className="footer-link">Terms of Service</a>
        </div>
        <div className="footer-bottom">
          <span className="footer-copy">&copy; 2026 Kin Health. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
